module.exports = __webpack_public_path__ + "c6eae0a05639f7f02576abed72972d98.svg";